<template>
<div>
    <Breadcrumbs main="Admin" submain="AI Hub" title="Prompt Category" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Category</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="category_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(name)="row">
                                        <div v-if="row.item.name" style="min-width: 150px; max-width: 250px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7>{{ row.item.name }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(model_name)="row">
                                        <div v-if="row.item.model_name" style="min-width: 150px; max-width: 200px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7>{{ row.item.model_name }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCategory(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editCategory(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Category Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Category" size="lg" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter category title" v-model="category.name">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Model Name</label>
                        <input class="form-control" type="text" placeholder="Enter model name" v-model="category.model_name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Short Description</label>
                        <input class="form-control" type="text" placeholder="Enter short description" v-model="category.description">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Max Tokens</label>
                        <input class="form-control" type="number" placeholder="Enter max tokens" v-model="category.max_tokens">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Top P</label>
                        <input class="form-control" type="number" placeholder="Enter top p" v-model="category.top_p">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Temperature</label>
                        <input class="form-control" type="number" step="any" placeholder="Enter temperature" v-model="category.temperature">
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Frequency Penalty</label>
                        <input class="form-control" type="number" step="any" placeholder="Enter frequency penalty" v-model="category.frequency_penalty">
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Presence Penalty</label>
                        <input class="form-control" type="number" step="any" placeholder="Enter presence penalty" v-model="category.presence_penalty">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Category Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Category" size="lg" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter category title" disabled v-model="edit_category.name">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Model Name</label>
                        <input class="form-control" type="text" placeholder="Enter model name" v-model="edit_category.model_name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Short Description</label>
                        <input class="form-control" type="text" placeholder="Enter short description" v-model="edit_category.description">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Max Tokens</label>
                        <input class="form-control" type="number" placeholder="Enter max tokens" v-model="edit_category.max_tokens">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Top P</label>
                        <input class="form-control" type="number" placeholder="Enter top p" v-model="edit_category.top_p">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Temperature</label>
                        <input class="form-control" type="number" step="any" placeholder="Enter temperature" v-model="edit_category.temperature">
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Frequency Penalty</label>
                        <input class="form-control" type="number" step="any" placeholder="Enter frequency penalty" v-model="edit_category.frequency_penalty">
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Presence Penalty</label>
                        <input class="form-control" type="number" step="any" placeholder="Enter presence penalty" v-model="edit_category.presence_penalty">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Category Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this category?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'model_name',
                    label: 'Model',
                    sortable: true
                },
                {
                    key: 'temperature',
                    label: 'Temperature',
                    sortable: true
                },
                {
                    key: 'temperature',
                    label: 'Partner',
                    sortable: true
                },
                {
                    key: 'max_tokens',
                    label: 'Max Tokens',
                    sortable: true
                },
                {
                    key: 'top_p',
                    label: 'Top P',
                    sortable: true
                },
                {
                    key: 'frequency_penalty',
                    label: 'Frequency Penalty',
                    sortable: true
                },
                {
                    key: 'presence_penalty',
                    label: 'Presence Penalty',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            category: {
                name: "",
                description: "",
                model_name: "",
                temperature: 0.0,
                max_tokens: 0,
                top_p: 0,
                frequency_penalty: 0.0,
                presence_penalty: 0.0,
            },
            edit_category: {
                id: null,
                name: "",
                description: "",
                model_name: "",
                temperature: 0.0,
                max_tokens: 0,
                top_p: 0,
                frequency_penalty: 0.0,
                presence_penalty: 0.0,
            },
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            category_list: state => state.key.category,
            loading: state => state.key.categoryLoading,
            error: state => state.key.categoryError,
        }),

        sortOptions() {
            return this.tablefields.filter(f => f.sortable).map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch("key/fetchCategory").then(() => {
            this.items = this.category_list
            this.totalRows = this.category_list.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.category.name = ""
            this.category.description = ""
            this.category.model_name = ""
            this.category.temperature = 0.0
            this.category.max_tokens = 0
            this.category.top_p = 0
            this.category.frequency_penalty = 0.0
            this.category.presence_penalty = 0.0
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("key/addCategory", this.category).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCategory(detail) {
            this.edit_category.id = detail.id ? detail.id : null
            this.edit_category.name = detail.name ? detail.name : null
            this.edit_category.description = detail.description ? detail.description : null
            this.edit_category.model_name = detail.model_name ? detail.model_name : null
            this.edit_category.temperature = detail.temperature ? detail.temperature : 0.0
            this.edit_category.max_tokens = detail.max_tokens ? detail.max_tokens : 0
            this.edit_category.top_p = detail.top_p ? detail.top_p : 0
            this.edit_category.frequency_penalty = detail.frequency_penalty ? detail.frequency_penalty : 0.0
            this.edit_category.presence_penalty = detail.presence_penalty ? detail.presence_penalty : 0.0
        },

        resetEditModal() {
            this.edit_category.name = ""
            this.edit_category.description = ""
            this.edit_category.model_name = ""
            this.edit_category.temperature = 0.0
            this.edit_category.max_tokens = 0
            this.edit_category.top_p = 0
            this.edit_category.frequency_penalty = 0.0
            this.edit_category.presence_penalty = 0.0
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("key/updateCategory", {
                id: this.edit_category.id,
                category: this.edit_category
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCategory(slug) {
            this.delete_value = slug
        },

        handleDeleteOk() {
            this.$store.dispatch("key/deleteCategory", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
